"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialNihilism = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Resources_1 = require("../../../Resources");
class SocialNihilism {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.SOCIAL_NIHILISM;
        this.description = 'Lose 2 M€ for each City tile and colony (no limit), then reduced by influence.';
        this.revealedDelegate = PartyName_1.PartyName.TRANSHUMANS;
        this.currentDelegate = PartyName_1.PartyName.SPOME;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const totalCount = player.getCitiesCount() + player.getColoniesCount() - turmoil.getPlayerInfluence(player);
            if (totalCount > 0)
                player.deductResource(Resources_1.Resources.MEGACREDITS, totalCount * 2, { log: true });
        });
    }
}
exports.SocialNihilism = SocialNihilism;
//# sourceMappingURL=SocialNihilism.js.map